<template>
  <div class="container-fluid p-3">
    <div class="row">
      <div class="col-md-3">
        <div class="card">
          <div class="card-header">
            <h6 class="text-center">DATOS PERSONALES</h6>
          </div>
          <div class="card-body">
            Nombre Completo:<br />
            {{ persona.per_nombres }} {{ persona.per_primer_apellido }}
            {{ persona.per_segundo_apellido }}
            <hr />
            Tipo de Documento:<br />
            {{ persona.tipo_documento }}
            <hr />
            Número de Documento:<br />
            {{ persona.per_numero_documento }}
            <hr />
            Fecha de Nacimiento:<br />
            {{ persona.per_fecha_nacimiento }}
            <hr />
            Nacionalidad:<br />
            {{ persona.nacionalidad }}
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="card">
          <div class="card-header">
            <h6 class="text-center">DECLARACIÓN JURADA DE DOMICILIO</h6>
          </div>
          <div class="col-md-12" v-show="disabledRes == 1">
            <div
              class="alert alert-warning"
              role="alert"
              style="background-color: rgba(248, 214, 43, 0.3);color:#000;"
            >
              <i class="fa fa-exclamation-triangle"></i> <b>Atención</b><br />
              El ciudadano extranjero deberá ingresar correctamente en el campo
              <b>* Nro. Documento Titular </b> el
              <b>número de cédula de identidad del propietario</b> de
              domicilio.<br />
              En caso de no lograr registrarse comuníquese a
                <b> (591-2) 2110960 interno 6021 - 6022</b>
            </div>
          </div>
          <div class="col-md-12" v-show="disabledRes !== 1">
            <div
              class="alert alert-warning"
              role="alert"
              style="background-color: rgba(248, 214, 43, 0.3);color:#000;"
            >
              <i class="fa fa-exclamation-triangle"></i> <b>Atención</b><br />
              
              Registro para los <b>Hoteles, Alojamientos, Hostales, Moteles y otros centros de hospedaje</b><br> En caso de no lograr registrarse comuníquese a
               <b> (591-2) 2110960 interno 6021 - 6022</b>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="row form-group">
                  <div class="col-12 col-md-12">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="HOS"
                        name="tipo_domicilio"
                        id="rdHOS"
                        :class="{
                          'is-invalid': $v.domicilio.tipo_domicilio.$error,
                        }"
                        v-model="domicilio.tipo_domicilio"
                        @change="onChangeTipoDomicilio($event)"
                      />
                      <label class="form-check-label" for="rdHOS"
                        >Centro de Hospedaje</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="RES"
                        name="tipo_domicilio"
                        id="rdRES"
                        :class="{
                          'is-invalid': $v.domicilio.tipo_domicilio.$error,
                        }"
                        v-model="domicilio.tipo_domicilio"
                        @change="onChangeTipoDomicilio($event)"
                      />
                      <label class="form-check-label" for="rdRES"
                        >Residencia</label
                      >
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-12 col-md-12">
                    <label>Departamento:</label>
                    <select
                      class="form-control"
                      v-model="domicilio.departamento"
                      :disabled="disabledND == 1"
                      @change="onChangeDepartamento($event)"
                    >
                      <option value="">SELECCIONAR</option>
                      <option
                        v-for="(item, index) in departamentos"
                        :value="item.codigo_departamento"
                        :key="index"
                        >{{ item.nombre_departamento }}</option
                      >
                    </select>
                  </div>
                </div>
                <div class="row form-group" v-show="disabledRes == 1">
                  <div class="col-12 col-md-12">
                    <label>* Nro. Documento Titular:</label>
                    <!--<input
                      type="number"
                      class="form form-control"
                      v-model="domicilio.nro_documento"
                      placeholder="Nro. Documento Titular"
                      :disabled="nro_documentoVerificado"
                      @blur="verificaSegipPersonas"
                    />-->
                     <span
                  class="text-danger lb-error"
                  v-if="!$v.domicilio.nro_documento.letras"
                  >Solo debe ingresar letras y números
                </span>

                    <input
                      type="text"
                      class="form form-control"
                      v-model="domicilio.nro_documento"
                      @keyup="domicilio.nro_documento = domicilio.nro_documento.toUpperCase()"
                      placeholder="Nro. Documento Titular"
                     
                    />
                  </div>
                  </div>
                   <!-- <div v-show="disabledRes == 1">
                      <input
                       v-show="disabledRes == 1"
                        type="checkbox"
                        v-model="picked"
                        true-value="yes"
                        :click="picked1=false"
                      ><label>*Complemento:</label>
                      </div> -->
                <!-- <div class="row form-group" v-show="disabledRes == 1">
                  <div class="col-12 col-md-6">
                    
                    <input
                      type="text"
                      class="form form-control"
                      :disabled="picked==true"
                      :abled="picked1==true"
                      v-model="domicilio.complemento"
                      @keyup="domicilio.complemento = domicilio.complemento.toUpperCase()"
                      placeholder="--"/>
                  </div>
                </div> -->
                <div class="row form-group" v-if="disabledHos == 1">
                  <div class="col-12 col-md-12">
                    <label class="mr-1">Hospedaje:</label>
                    <v-select
                        placeholder="SELECCIONAR / BUSCAR"
                        :options="empresas"
                        :get-option-label="(option) => option.empresa"
                        v-on:input="onChangeEmpresa($event)"
                        >
                      <template v-slot:option="option">
                        {{option.empresa}}
                        <br>
                        <cite><p style="font-size: 11px; letter-spacing: -1px;">{{option.lugar}}</p></cite>
                      </template>
                      <div slot="no-options">No existen opciones</div>
                    </v-select>
                  </div>
                </div>
              <div class="row form-group" v-if="disabledEmp == 1">
               
                  <div class="col-12 col-md-12">
                    <label class="mr-1">Tipo Hospedaje:</label>
                    <select
                      class="form-control"
                     v-model="domicilio.tipo_hospedaje"
                    >
                      <option value="">SELECCIONAR</option>
                      <option value="HOTEL">HOTEL</option>
                      <option value="HOSTAL">HOSTAL</option>
                      <option value="ALOJAMIENTO">ALOJAMIENTO</option>
                      <option value="OTRO">OTRO</option>
                    </select>
                  </div>
                
                </div>
                <div
                  class="row form-group"
                  v-if="disabledRes == 1 || disabledEmp == 1"
                >
                  <div class="col-12 col-md-12">
                    <label>{{ lbNombreDomicilio }}</label>
                    <input
                      type="text"
                      placeholder="Ej.: Carlos Lopez"
                      class="form-control"
                      v-model="domicilio.nombre_domicilio"
                      
                      @keyup="domicilio.nombre_domicilio = domicilio.nombre_domicilio.toUpperCase()"
                    />
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-12 col-md-12">
                    <label>Dirección:</label>
                    <input
                      class="form-control"
                      v-model="domicilio.direccion"
                      :disabled="disabledHos == 1"
                      @keyup="
                        domicilio.direccion = domicilio.direccion.toUpperCase()
                      "
                      placeholder="ej.: C/ ALFONSO UGARTE #234"
                    />
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-12 col-md-12 ">
                    <label>Teléfono:</label>
                    <input
                      type="text"
                      placeholder="Ej.: 5225500"
                      v-model.lazy="domicilio.telefono"
                      class="form-control"
                      :disabled="disabledHos == 1"
                    />
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col-12 col-md-12">
                    <label>Fecha Desde:</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="domicilio.fecha_inicio"
                      :disabled="disabledND == 1"
                      :min="fechaMin"
                      :max="fechaMax"
                      @change="onChangeFechaIni($event)"
                    />
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-12 col-md-12">
                    <label>Fecha Hasta:</label>
                    <input
                      type="date"
                      class="form-control"
                      id="fecha_fin"
                      v-model="domicilio.fecha_fin"
                      :min="fechaFinMin"
                      :max="fechaFinMax"
                      :disabled="disabledND == 1"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-8">
                <div class="row">
                  <div class="col-12 col-md-12 form-group">
                  
                    <label class="mr-1"
                      >Fotografía del frontis de domicilio:</label
                    ><br />
                    <input
                      type="file"
                      id="file"
                      ref="file"
                      accept="image/*"
                      @change="uploadImage($event)"
                      v-if="disabledHos != 1"
                    />
                  </div>
                  <div class="mx-auto text-center">
                    <output id="list" v-if="disabledRes == 1"></output>
                    <img
                      class="img-fluid"
                     width="80%"
                     height="50%"
                      :src="`${datourl+this.domicilio.id_empresa}`"
                      v-if="disabledHos == 1"
                    />
                  </div>
                </div>

                <div class="row form-group">
                  <div class="col-12 col-md-12">

                  </div>

                  <div class="col-12 col-md-12">
                    <div >
                      <l-map v-if="showMap" :zoom="zoom" :center="center" :options="mapOptions" style="width: 100%; height: 360px" @update:center="centerUpdate(domicilio.latitud, domicilio.longitud)" @click="get_coordenadas">
<!--                        <v-tilelayer :url="url" :attribution="attribution"></v-tilelayer>-->
                        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

                          <l-marker :lat-lng="latlng(domicilio.latitud, domicilio.longitud)" v-if="disabledHos == 1">
                            <l-popup>
                              <div>
                                <b-card>
                                  <template #header>
                                    <h4 class="mb-0">Departamento</h4>
                                  </template>
                                  <b-card-body>                                
                                    <b-card-sub-title class="mb-2">{{domicilio.departamento}}</b-card-sub-title>
                                    <b-card-text>
                                    {{domicilio.direccion}}
                                    </b-card-text>
                                  </b-card-body>
                                </b-card>
                              </div>
                            </l-popup>                   
                          </l-marker>
                        <l-marker
                            :lat-lng="latlng(latitud, longitud)"
                            v-else>
                        </l-marker>
                        <v-geosearch :options="geosearchOptions" marker="false"></v-geosearch>
                      </l-map>
                    </div> 
                  </div>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-4"></div>
              <div class="col-12 col-md-4">
                <router-link
                  :to="{ name: 'historialdeclaracion' }"
                  class="btn btn-primary btn-block"
                >
                  <small> Cancelar</small>
                </router-link>
              </div>
              <div class="col-12 col-md-4">
                <button
                  type="button"
                  class="btn btn-success btn-block"
                  @click="procesarDomicilio"
                >
                  <small>Registrar</small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import { required, helpers } from "vuelidate/lib/validators";
import moment from "moment";
const letras = helpers.regex("alpha", /^[A-Z1234567890]*$/);
//import GoogleMap from "../../components/GoogleMap";
import 'leaflet/dist/leaflet.css';
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
//import { L } from "vue2-leaflet";
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import { Icon, latLng  } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import 'vue-select/dist/vue-select.css';
export default {
  name: "declaracion",
  components: {
    Loading,
     // GoogleMap,
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  data() {
    
    return {
      imagendomicilio:'',
      datourl:process.env.VUE_APP_URL+'/imagen/',
      zoom: 5,
      zoomLapaz: 5,
      center: latLng(-16.290154,-63.588653),
      centerLapaz: latLng(-16.290154,-63.588653),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(47.41322, -1.219482),
      withTooltip: latLng(47.41422, -1.250482),
      currentZoom: '',
      currentCenter: latLng(-16.5157398,-68.1257891),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
       mapOptionsLapaz: {
        zoomSnap: 0.8
      },
      geosearchOptions: { // Important part Here
        provider: new OpenStreetMapProvider(),
        notFoundMessage: 'Lo sentimos, esa dirección no se pudo encontrar.',
        autoClose: true,
        searchLabel: 'Ingresa la dirección',
      },
      showMap: true,
      picked:true,
      picked1:false,
      elegido: {},
      latitud:'',
      longitud:'',
      nro_documentoVerificado: false,
      persona: {
        id_persona: 0,
        per_nombres: "",
        per_per_primer_apellido: "",
        per_per_segundo_apellido: "",
        per_fecha_nacimiento: "",
        per_email: "",
        par_tipo_documento: "",
        per_numero_documento: "",
        par_nacionalidad: "",
        tipo_persona: 3,
      },
      selected: '',
      domicilio: {
        id_persona: 0,
        tipo_domicilio: "HOS",
        nombre_domicilio: "",
        direccion: "",
        telefono: "",
        fecha_inicio: null,
        fecha_fin: null,
        tipo_documento: "",
        nro_documento: "",
        departamento: "LPG",
        latitud: '',
        longitud: '',
        id_empresa: "",
        empresa_persona: 0,
        zoom:'',
        tipo_hospedaje:''

      },
      disabledHos: 1,
      disabledRes: 0,
      disabledND: 0,
      empresa:'',
      cargando: false,
      submitted: false,
      empresas: [],
      departamentos: [],
      resultados: [],
      imagen: {
        base64: "",
        content: "",
      },
      fechaMin: new moment().format("YYYY-MM-DD"),
      fechaMax: moment().add(1, 'year').format("YYYY-MM-DD"),
      disabledEmp: 0,
      lbNombreDomicilio: "Nombre de Titular:",
    };
  },
  computed: {
    fechaFinMin() {
      return this.domicilio.fecha_inicio;
    },
    fechaFinMax() {
      if (this.domicilio.fecha_inicio) {
        return moment(this.domicilio.fecha_inicio).add(1, 'year').format("YYYY-MM-DD");
      } else {
        return null; 
      }
    }
  },
  methods: {
    
    latlng(lat, lng){
      return latLng(lat, lng);
    },
    zoomUpdate(zoom) {
      //console.log(zoom);
      this.currentZoom = zoom;
      ///console.log("zoom",this.currentZoom);
    },
    centerUpdate(lat, lng) {
      this.currentCenter = latLng(lat,lng);
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    
    async getPersona() {
      try {
        let res = await this.axios.post(`/extranjeroGetData`);
        this.persona = res.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    get_coordenadas(e) {
      this.latitud = e.latlng.lat;
      this.longitud = e.latlng.lng
      //this.markernew = {pos:pos}
      /*let coord = e.latlng;
      let lat = coord.lat;
      let lng = coord.lng;
      // console.log("You clicked the map at latitude: " + lat + " and longitude: " + lng);
      let xy = LatLonToUTMXY2(lat, lng, 30);
      // console.log("You clicked the map at X: " + xy[0] + " and Y: " + xy[1]);
      this.$emit('get_coordenadas', xy);*/
    },
    async procesarDomicilio() {
      if (
        this.domicilio.departamento == undefined ||
        this.domicilio.departamento == ""
      ) {
        this.$swal({
          title: "Información",
          html: "Seleccione <b>Departamento</b>.",
          type: "info",
          confirmButtonText: "Aceptar",
        });

        return;
      }

      if (this.disabledHos == 1) {
        //this.domicilio.nombre_domicilio = "";
        if (
          this.domicilio.id_empresa == 0 ||
          this.domicilio.id_empresa == undefined
        ) {
          this.$swal({
            title: "Información",
            html: "Seleccione <b>Hospedaje</b>",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }
          
        this.domicilio.latitud = Number(this.empresa.emp_latitud);
        this.domicilio.longitud = Number(this.empresa.emp_longitud);
      } else {
        this.domicilio.latitud = this.latitud;
        this.domicilio.longitud = this.longitud;
      }

      // Validacion para campos para residencia
      if (this.disabledRes == 1) {
        this.domicilio.id_empresa = 0;
        if (
          this.domicilio.nombre_domicilio == undefined ||
          this.domicilio.nombre_domicilio == ""
        ) {


          this.$swal({
            title: "Información",
            text:
              "Ingrese Nombre completo del Titular ",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          this.domicilio.nro_documento == undefined ||
          this.domicilio.nro_documento == ""
        ) {
          this.$swal({
            title: "Información",
            text: "Ingrese Número de documento",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }
        if (
          this.domicilio.direccion == undefined ||
          this.domicilio.direccion == ""
        ) {
          this.$swal({
            title: "Información",
            text: "Ingrese dirección",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }
        // if (
        //   this.domicilio.telefono == undefined ||
        //   this.domicilio.telefono == ""
        // ) {
        //   this.$swal({
        //     title: "Información",
        //     html: "Ingrese <b>Teléfono</b>.",
        //     type: "info",
        //     confirmButtonText: "Aceptar",
        //   });

          //return;
        //}

        if (this.domicilio.latitud == "" || this.domicilio.longitud == "") {
          this.$swal({
            title: "Información",
            text: "Debe Seleccionar una Ubicación en el Mapa",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (this.file == undefined) {
          this.$swal({
            title: "Información",
            html:
              "Debe cargar una <b>Imagen</b> del frontis del <b>Centro de Hospedaje</b> o <b>Residencia</b>.",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }
      }

      // Validacion para campos comunes
      if (
        this.domicilio.fecha_inicio == undefined ||
        this.domicilio.fecha_inicio == ""
      ) {
        this.$swal({
          title: "Información",
          html: "Ingrese la <b>Fecha Inicio</b>.",
          type: "info",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      if (
        this.domicilio.fecha_fin == undefined ||
        this.domicilio.fecha_fin == ""
      ) {
        this.$swal({
          title: "Información",
          html: "Ingrese la <b>Fecha Fin</b>.",
          type: "info",
          confirmButtonText: "Aceptar",
        });
        return;
      }
      if (this.disabledEmp == 1) {
        this.domicilio.empresa_persona = 1;
      }

      

      this.$v.$touch();
      if (this.$v.$invalid) {
       
        this.cargando = false;
        return;
      }
      this.$swal({
        title: "Esta Seguro?",
        html: "De confirmar la <b>Declaración Jurada de Domicilio</b>",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Aceptar la Declaracion",
      })
      .then(async (result) => {
        if (result.value) {

      try {

         
         
        
     
        this.domicilio.id_persona = this.persona.id_persona;
        
        //console.log(this.domicilio);
        let res = await this.axios.post(`/domicilio`, this.domicilio);

        if (this.disabledRes == 1) {
          let config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };

          let formData = new FormData();
          formData.append("archivo", this.file);

          await this.axios.put(
            `/upload/frontis/${res.data.contenido.id_domicilios}`,
            formData,
            config
          );
        }

        if (res.status === 200) {
          this.$swal({
            title: "Información",
            html:
              "Datos adicionados, en <b>historial de declaración</b> confirme su <b>Declaración de Domicilio</b>.",
            type: "success",
            confirmButtonText: "Aceptar",
          });
          this.$router.push("historialDeclaracion");
        }
      } catch (error) {
        this.$swal({
          title: "Información",
          text: "Ocurrio un error",
          type: "error",
          confirmButtonText: "Aceptar",
        });
        this.cargando = false;
      }
      }
      });
    },
    onChangeTipoDomicilio() {
      let opcion = this.domicilio.tipo_domicilio;
      switch (opcion) {
        case "HOS":
          this.disabledHos = 1;
          this.disabledRes = 0;
          this.disabledND = 0;
          // this.domicilio.latitud = -16.5157398;
          // this.domicilio.longitud = -68.1257891;
          // this.domicilio.departamento = 'LA PAZ';
          break;
        case "RES":
          this.disabledHos = 0;
          this.disabledRes = 1;
          this.disabledND = 0;
          this.disabledEmp = 0;
          this.lbNombreDomicilio = "Nombre de Titular:";
          // this.domicilio.latitud = -16.5157398;
          // this.domicilio.longitud = -68.1257891;
          // this.domicilio.departamento = 'LA PAZ';          
          break;
        case "ND":
          this.disabledHos = 0;
          this.disabledRes = 0;
          this.disabledND = 1;
          break;
        
      }
      this.LimpiarDomicilio();
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    uploadImage(evt) {
      this.file = this.$refs.file.files[0];

      let files = evt.target.files;
      for (let i = 0, f; (f = files[i]); i++) {
        if (!f.type.match("image.*")) {
          continue;
        }
        let reader = new FileReader();
        reader.onload = (function(theFile) {
          return function(e) {
            document.getElementById("list").innerHTML = [
              '<img class="img-responsive img-thumbnail text-center" width="350px" height="250px" src="',
              e.target.result,
              '" title="',
              escape(theFile.name),
              '"/>',
            ].join("");
          };
        })(f);
        reader.readAsDataURL(f);
      }
    },
    capturaCoordenadas(value) {
   
      this.domicilio.latitud = value.lat;
      this.domicilio.longitud = value.lng;
    },
    setPlace(event) {
      this.domicilio.latitud = event.geometry.location.lat();
      this.domicilio.longitud = event.geometry.location.lng();
      this.domicilio.direccion = event.name;
      this.domicilio.departamento = event.address_components[3].long_name.toUpperCase();
    },
    async obtenerLugar() {
      let estaPos = await this.posicionNavegador();
     console.log(estaPos);
    },
    posicionNavegador() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            let pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            return pos;
          },
        );
      } 
    },
    async getEmpresasHospedaje() {
      try {
        let resultado = await this.axios.get(`/empresa/empresaByRubro/3`);
        this.empresas = resultado.data.contenido;
      } catch (error) {
        this.$swal({
          title: "Información",
          text: "Ocurrio un Error al realizar la consulta!",
          type: "error",
          confirmButtonText: "Aceptar",
        });
      }
    },

    async verificaSegip() {
      if (
        this.domicilio.nro_documento != "" &&
        this.domicilio.nro_documento != undefined &&
        this.domicilio.nro_documento.length >= 6
      ) {
        this.cargando = true;
        try {
          let config = {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_TOKEN_SEGIP}`,
            },
          };
          let data = {
            ced: this.domicilio.nro_documento,
            com: "",
            nom: "",
            pat: "",
            mat: "",
          };

          let resultado = await this.axios.post(
            `https://app.mingobierno.gob.bo/segipwsexterno`,
            data,
            config
          );

          this.cargando = false;
          if (resultado.status === 200 && resultado.data.Nombres !== undefined) {
            this.domicilio.nombre_domicilio = `${resultado.data.Nombres} ${resultado.data.PrimerApellido} ${resultado.data.SegundoApellido}`;
            this.domicilio.direccion = resultado.data.Domicilio;
            this.nro_documentoVerificado = true;
          } else {
            console.log("No existen coincidencias");
          }
        } catch (error) {
          this.cargando = false;
          console.log(error);
        }
      }
    },
    async verificaSegipPersonas() {
      try {
        if (this.domicilio.nro_documento != "" && this.domicilio.nro_documento != undefined && this.domicilio.nro_documento.length >= 6) {
          let data = {
            per_nombres: "",
            per_primer_apellido: "",
            per_segundo_apellido: "",
            per_numero_documento: this.domicilio.nro_documento,
            per_complemento:"",
          };
          let resultado = await this.axios.post(`/VerificaSegipPersona`, data);
          let datoPersona = resultado.data.contenido;
          this.cargando = false;

          if (resultado.status === 200) {
            if(resultado.data.contenido.respuesta){
              this.$swal({
                html: "No existen coincidencias",
                type: "info",
                confirmButtonText: "Aceptar",
              });
            }
            else{
              this.domicilio.nombre_domicilio = `${datoPersona.Nombres} ${datoPersona.PrimerApellido} ${datoPersona.SegundoApellido}`;
              this.domicilio.direccion = datoPersona.Domicilio;

              this.nro_documentoVerificado = true;
            }
          } else {
            console.log("No existen coincidencias");
          }
        
        }
      } catch (error) {
          this.cargando = false;
          console.log(error);
          this.$swal({
            html: "No existen coincidencias",
            type: "info",
            confirmButtonText: "Aceptar",
          });

        }
    },
    async verificaSegipPersonasComplemento() {
      try {
        if (this.domicilio.complemento != "" && this.domicilio.complemento != undefined && this.domicilio.complemento.length >= 2) {
          let data = {
            per_nombres: "",
            per_primer_apellido: "",
            per_segundo_apellido: "",
            per_numero_documento: this.domicilio.nro_documento,
            per_complemento: this.domicilio.complemento,
          };
          let resultado = await this.axios.post(`/VerificaSegipPersona`, data);
          let datoPersona = resultado.data.contenido;
          this.cargando = false;
          if (resultado.status === 200) {
            this.domicilio.nombre_domicilio = `${datoPersona.Nombres} ${datoPersona.PrimerApellido} ${datoPersona.SegundoApellido}`;
            this.domicilio.direccion = datoPersona.Domicilio;

            this.nro_documentoVerificado = true;
          } else {
            console.log("No existen coincidencias");
          }
        
        }
      } catch (error) {
          this.cargando = false;
          console.log(error);
          this.$swal({
            html: "No existen coincidencias",
            type: "info",
            confirmButtonText: "Aceptar",
          });

        }
    },
    async getDepartamentos() {
      try {
        this.empresas = [];
        let resultados = await this.axios.get(`/getDepartamentos`);
        this.departamentos = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async onChangeDepartamento(event) {
      try {
        let departamento =
          event.target.options[event.target.selectedIndex].value;
        this.domicilio.departamento = departamento;
        let resultado = await this.axios.get(
          `/getEmpresaDepartamento/${departamento}`
        );
        this.empresas = resultado.data.contenido;
        if (this.empresas.lenght == "" || this.empresas == undefined) {
          this.empresas = [];
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async onChangeEmpresa(event) {
      try {
        this.domicilio.id_empresa= event.id_empresa;
        this.domicilio.nombre_domicilio = event.empresa;
        if (
          this.domicilio.nombre_domicilio ==
          "OTRO"
        ) {
          this.disabledHos = 0;
          this.disabledEmp = 1;
          this.domicilio.nombre_domicilio = "";
          this.lbNombreDomicilio = "Nombre del Hospedaje:";
        } else {
          let resultado = await this.axios.get(
            `/getEmpresaDescripcion/${this.domicilio.id_empresa}`
          );
          let datoEmpresa = resultado.data.contenido[0];
          this.empresa = datoEmpresa;
          // Carga Mapa
          this.domicilio.direccion = datoEmpresa.emp_direccion;
          this.domicilio.telefono = datoEmpresa.emp_telefono;
          this.domicilio.latitud = Number(datoEmpresa.emp_latitud);
          this.domicilio.longitud = Number(datoEmpresa.emp_longitud);
          this.domicilio.zoom = Number(datoEmpresa.zoom);
          // Carga Imagen
          let imagen = datoEmpresa.nombre_imagen;
          let rutaImg = await this.axios.get(
            `/imagenMostrar/frontis/${imagen}`
          );
          this.imagen.base64 = rutaImg.data.imagen;
          this.imagen.content = rutaImg.data.content;
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async onLoadImageDefault() {
      let rutaImg = await this.axios.get(`/imagenMostrar/f/default`);
      this.imagen.base64 = rutaImg.data.imagen;
      this.imagen.content = rutaImg.data.content;
    },
    onChangeFechaIni(event) {
      let fecha = event.target._value;
      document.getElementById("fecha_fin").setAttribute("min", fecha);
    },
    LimpiarDomicilio() {
      this.domicilio = {
        id_persona: 0,
        tipo_domicilio: this.domicilio.tipo_domicilio,
        nombre_domicilio: "",
        direccion: "",
        telefono: "",
        fecha_inicio: null,
        fecha_fin: null,
        tipo_documento: "",
        nro_documento: "",
        departamento: "LPG",
        latitud: '',
        longitud: '',
        id_empresa: "",
      };
    },
    async onLoadEmpresas() {
      let resultado = await this.axios.get(`/getEmpresaDepartamento/LPG`);
      this.empresas = resultado.data.contenido;
      if (this.empresas.lenght == "" || this.empresas == undefined) {
        this.empresas = [];
      }
    },
    async Verifica() {
      this.cargando = true;
      try {
        this.cargando = true;
        //let res = await this.axios.get(`/noFinalizadoDomicilio`);
        let res = await this.axios.get(`/VerificaDomicilioVencido`);
        //let count = res.data.contenido;
        let count = res.data.contenido.length;
        this.cargando = false;
        if (count >= 1) {
          this.$swal({
            title: "Información",
            html:
              "<b>Usted tiene pendiente</b><br><b>Confirme</b> la última declaración jurada de domicilio.",
            type: "info",
            confirmButtonText: "Aceptar",
          })
          .then((result) => {
            if (result.value) {
              this.$router.push("historialdeclaracion");
           }
           console.log(result);
          });
        }
      } catch (error) {
        this.cargando = false;
      }
    },
  },
  created() {
    this.Verifica();
    this.getPersona();
    this.getDepartamentos();
    this.onLoadImageDefault();
    this.onLoadEmpresas();
  },

  validations: {
    domicilio: {
      tipo_domicilio: { required },
      nro_documento:{letras},
    },
  },
};
</script>
<style>
/* global styling */
.leaflet-control-geosearch *,
.leaflet-control-geosearch *:before,
.leaflet-control-geosearch *:after {
  box-sizing: border-box;
}

/* leaflet button styling */
.leaflet-control-geosearch .leaflet-bar-part {
  border-radius: 4px;
  border-bottom: none;
}

.leaflet-control-geosearch a.leaflet-bar-part:before,
.leaflet-control-geosearch a.leaflet-bar-part:after {
  position: absolute;
  display: block;
  content: '';
}

/* magnifying glass */
.leaflet-control-geosearch a.leaflet-bar-part:before {
  top: 19px;
  left: 16px;
  width: 8px;
  border-top: 2px solid #555;
  transform: rotateZ(45deg);
}

.leaflet-control-geosearch a.leaflet-bar-part:after {
  top: 6px;
  left: 6px;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  border: 2px solid #555;
}

/* resets for pending and error icons */
.leaflet-control-geosearch.error a.leaflet-bar-part:before,
.leaflet-control-geosearch.pending a.leaflet-bar-part:before {
  display: none;
}

.leaflet-control-geosearch.pending a.leaflet-bar-part:after,
.leaflet-control-geosearch.error a.leaflet-bar-part:after {
  left: 50%;
  top: 50%;
  width: 18px;
  height: 18px;
  margin: -9px 0 0 -9px;
  border-radius: 50%;
}

/* pending icon */
.leaflet-control-geosearch.pending a.leaflet-bar-part:after {
  content: '';
  border: 2px solid #555;
  border-top: 2px solid #f3f3f3;
  animation: spin 1s linear infinite;
}

/* error icon */
.leaflet-control-geosearch.error a.leaflet-bar-part:after {
  content: '!';
  line-height: initial;
  font-weight: 600;
  font-size: 18px;
  border: none;
}

/* search form styling */
.leaflet-control-geosearch form {
  display: none;
  position: absolute;
  top: -2px;
  left: 28px;
  border-radius: 0 4px 4px 0;
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-left: none;
  background-color: #fff;
  background-clip: padding-box;
  z-index: -1;
  height: auto;
  margin: 0;
  padding: 0 8px;
}

.leaflet-control-geosearch.active form {
  display: block;
}

.leaflet-control-geosearch form input {
  min-width: 200px;
  width: 100%;
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  font-size: 12px;
  height: 30px;
  border-radius: 0 4px 4px 0;
  text-indent: 8px;
}

.leaflet-control-geosearch .results {
  background: #fff;
}

.leaflet-control-geosearch .results > * {
  line-height: 24px;
  padding: 0 8px;
  border: 1px solid transparent;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.leaflet-control-geosearch .results.active {
  padding: 8px 0;
  border-top: 1px solid #c6c6c6;
}

.leaflet-control-geosearch .results > .active,
.leaflet-control-geosearch .results > :hover {
  background-color: #f8f8f8;
  border-color: #c6c6c6;
  cursor: pointer;
}

/* add missing border to form */
.leaflet-control-geosearch .results.active:after {
  content: '';
  display: block;
  width: 0;
  border-left: 2px solid rgba(0, 0, 0, .2);
  position: absolute;
  left: -2px;
  bottom: -2px;
  top: 30px;
}

/* animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.leaflet-top .leaflet-control-geosearch.bar,
.leaflet-bottom .leaflet-control-geosearch.bar {
  display: none;
}

.leaflet-control-geosearch.bar {
  position: relative;
  display: block;
  height: auto;
  width: 400px;
  margin: 10px auto 0;
  cursor: auto;
  z-index: 1000;
}

.leaflet-control-geosearch.bar form {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.leaflet-control-geosearch.bar form input {
  min-width: 100%;
  width: 100%;
}

.leaflet-control-geosearch.bar .results.active:after {
  opacity: .2;
}

.leaflet-right .leaflet-control-geosearch form {
  right: 28px;
  left: initial;
  border-radius: 4px 0 0 4px;
  border-left: inherit;
  border-right: none;
}

.leaflet-control-geosearch a.reset {
  color: black;
  position: absolute;
  line-height: 30px;
  padding: 0 8px;
  right: 0;
  top: 0;
  cursor: pointer;
  border: none;
}

.leaflet-control-geosearch a.reset:hover {
  background: #f5f5f5;
}
</style>